import React from 'react'

export const EmailIcon = () => (
  <svg width="24" height="24">
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <path
        fill="#FFF"
        d="M19 6a2 2 0 012 2v9a2 2 0 01-2 2H5a2 2 0 01-2-2V8a2 2 0 012-2h14zm.16 2.144a.75.75 0 00-1.016-.304L12 11.148 5.856 7.84a.75.75 0 10-.712 1.32l6.5 3.5c.222.12.49.12.712 0l6.5-3.5a.75.75 0 00.304-1.016z"
      />
    </g>
  </svg>
)
